import { ChangeDetectionStrategy, Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantService } from '@vsolv/core/multi-tenant/web';
import { FirebaseService } from '@vsolv/packages/firebase/web';
import { PortalService } from '@vsolv/packages/portal-config/web';
import { StatusTypes } from '@wsphere/customer-portal/web';
import { firstValueFrom } from 'rxjs';

@Component({ changeDetection: ChangeDetectionStrategy.Eager, templateUrl: './login.page.html', standalone: false })
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class LoginPage implements OnInit {
  readonly statusTypes = StatusTypes;
  constructor(
    private firebaseSvc: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
    private portalSvc: PortalService,
    private tenantSvc: TenantService,
    private sanitizer: DomSanitizer
  ) {}
  errors = false;
  errorType?: string;
  redirect: string | null = null;
  contactPhone = '';
  loginDisabled = false;
  isClaimsPageVisit = false;
  claimsMessage = '';

  async ngOnInit() {
    const signedIn = await firstValueFrom(this.firebaseSvc.isSignedIn$());
    if (signedIn) {
      await this.router.navigateByUrl('../');
      return;
    }

    this.redirect = this.route.snapshot.queryParamMap.get('redirect');
    this.isClaimsPageVisit = this.isClaimsRedirect(this.redirect);

    try {
      const tenantId = await this.tenantSvc.getTenantIdFromDomain();
      if (!tenantId) {
        throw new Error('Missing tenant ID from domain.');
      }

      const config = await this.portalSvc.getOne(tenantId);
      this.contactPhone = config?.contactPhone ?? '';
      this.loginDisabled = config?.loginDisabled === true;
      this.claimsMessage = config?.claimsMessage ?? '';
    } catch (err) {
      console.error('Failed to load tenant config:', err);
      this.errors = true;
      this.loginDisabled = false;
    }
  }

  handleSignInError(error: string) {
    this.errors = !!error;
    this.errorType = error || undefined;
  }

  get sanitizedClaimsMessage(): string | null {
    if (!this.claimsMessage || this.claimsMessage.trim().length === 0) {
      return null;
    }
    return this.sanitizer.sanitize(SecurityContext.HTML, this.claimsMessage);
  }

  get contactPhoneLabel(): string {
    return this.contactPhone && this.contactPhone.trim().length > 0 ? this.contactPhone : 'your warranty provider';
  }

  private isClaimsRedirect(redirect: string | null): boolean {
    if (!redirect) {
      return false;
    }

    const path = redirect.split('?')[0];
    return path === '/claim' || path.startsWith('/claim/');
  }
}
